import styled from 'styled-components';

export const WrapperContainer = styled.div`
    position: relative;
    flex: 1;
    display: flex;
    overflow: visible;
    border-top: solid 1.2em #2E0011;
    border-bottom: solid 1.2em #FCC089;
    background: #FF9746;
    width: 100%;   
    height: 100vh;
    justify-content: center;
    align-items: center;
    padding: 0 20px;

    
    @media screen and (max-width: 425px) {
        padding: 0;
    }
`

export const PrimaveraOne = styled.img`
    position: absolute;
    z-index: 90;
    top: -20%; 
    right: -2px;
    width: 40%; 
    transform: scale(4) translateX(-80px);
    
    @media screen and (min-width: 768px) {
        width: 30%;
    }

    @media screen and (max-width: 768px) {
        width: 40%;
        transform: scale(2) translateX(-50px);
        right: -40px;
        top: -7%;
    }
    @media screen and (max-width: 450px) {
        width: 60%;
        transform: scale(2.7) translateX(-50px);
        right: -60px;
        top: -10%;
}
`

export const PrimaveraTwo = styled.img`
    position: absolute;
    width: 32%;
    left: -5px;
    bottom: -20%;
    z-index: 99;
    transform: scale(4) translateX(80px);

    @media screen and (min-width: 1024px) {
        width: 30%;
    }

    @media screen and (max-width: 1024px) {
        width: 35%;
        bottom: -15%;
    }
    @media screen and (max-width: 768px) {
        width: 50%;
        left: -30px;
        bottom: -10%;
    }
    @media screen and (max-width: 425px) {
        width: 60%;
        left: -20px;
        bottom: -5%;
}
`;



export const Container = styled.div`
    max-width: 1200px;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;  /* 2 colunas iguais */
    gap: 60px;  /* Espaço entre texto e imagem */
    align-items: center;
    z-index: 2;
    padding: 0 20px;

    @media screen and (max-width: 968px) {
        gap: 40px;
    }

    @media screen and (max-width: 768px) {
        grid-template-columns: 1fr;  /* 1 coluna no mobile */
        gap: 40px;
        text-align: center;
    }
`;

export const WrapperText = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
`;
    
export const Text = styled.h1`
    display: flex;
    font-size: 6rem;
    color: #2E0011;
    font-family: "Niconne";
    font-weight: normal;
    width: 100%;
    clamp(2.5rem, 5vw, 6rem);

    @media screen and (max-width: 768px) {
        font-size: clamp(3.5rem, 6vw, 5rem);
    }
    `
    
        
export const WrapperImgAmbiente = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
`;
        
export const ImgAmbiente = styled.img`
    width: 100%;
    max-width: 500px;  /* Limita o tamanho máximo */
    height: auto;
    object-fit: cover;

    @media screen and (max-width: 768px) {
        max-width: 80%;
    }
`

